export default __webpack_public_path__ + "static/media/newspaper.d2afa42d.png";